import {
  Boundary,
  Breadcrumb,
  type BreadcrumbProps,
  Breadcrumbs,
  type IconName,
  Tag,
} from "@blueprintjs/core";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

export interface InternalBreadcrumbProps {
  path: string;
  label: ReactNode;
  icon?: IconName;
}

const StyledBreadcrumb = styled(Breadcrumb)`
  text-wrap: nowrap;
`;

function renderCurrentBreadcrumb({ href, ...restProps }: BreadcrumbProps) {
  if (href) {
    return (
      <Link to={href}>
        <StyledBreadcrumb disabled={false} {...restProps} />
      </Link>
    );
  }
  return <StyledBreadcrumb {...restProps} />;
}

function BreadC({ path = [] }: { path: InternalBreadcrumbProps[] }) {
  const withRoot: InternalBreadcrumbProps[] = [
    { path: "/admin", label: "Admin", icon: "home" },
    ...path,
  ];

  const items: BreadcrumbProps[] = withRoot.map((path) => ({
    text: (
      <Tag icon={path.icon} size="large" minimal>
        {path.label}
      </Tag>
    ),
    href: path.path,
  }));

  return (
    <Breadcrumbs
      collapseFrom={Boundary.START}
      items={items}
      breadcrumbRenderer={renderCurrentBreadcrumb}
    />
  );
}

export default BreadC;
